import script from "./DeleteProductTypeConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteProductTypeConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteProductTypeConfirmDialog.vue?vue&type=style&index=0&id=896de9da&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-896de9da"]])

export default __exports__